import { Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appEnableEscClose]',
  standalone: true,
})
export class EnableEscCloseDirective implements OnInit, OnDestroy {
  private dialogRef = inject(MatDialogRef<unknown>, { optional: true });
  private document = inject(DOCUMENT);

  private onKeyDown = (event: KeyboardEvent): void => {
    if (event.code === 'Escape') {
      this.dialogRef?.close();
    }
  };

  public ngOnInit(): void {
    this.document.addEventListener('keydown', this.onKeyDown);
  }

  public ngOnDestroy(): void {
    this.document.removeEventListener('keydown', this.onKeyDown);
  }
}
